import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { TelephoneIcon } from '@repo/ui/icons'

import useEnrollment from '../../../../lib/hooks/use-enrollment'
import ClientSpacePageTitle from '../client-space-page-title'
import ClientEnrollmentCenterCard from './client-enrollment-center-card'

const ClientCenterContactWithTransport = () => {
  const { enrollment } = useEnrollment()

  return (
    <div className="flex flex-col gap-4">
      <ClientSpacePageTitle
        icon={<TelephoneIcon color={tailwindColors.primary.dark.DEFAULT} />}
        title="Coordonnées pendant le séjour"
      />
      {enrollment.enrollmentCenter?.center && (
        <ClientEnrollmentCenterCard
          enrollmentId={enrollment.id}
          data={enrollment.enrollmentCenter?.center}
        />
      )}
    </div>
  )
}

export default ClientCenterContactWithTransport
